import React from "react";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate
import classnames from "classnames";

// Import authentication functions
import { isAuthenticated, logout } from "utils/auth"; // Adjust path if needed

// reactstrap components
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip // Added for tooltip
} from "reactstrap";

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = React.useState(false); // State for login status
  const navigate = useNavigate(); // Hook for navigation

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  // Check login status on mount
  React.useEffect(() => {
    setIsUserLoggedIn(isAuthenticated());
  }, []); // Runs once on mount

  // Handle navbar color change on scroll
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  }, []);

  // Handle Logout
  const handleLogout = () => {
    logout(); // Call the logout function from utils/auth
    setIsUserLoggedIn(false); // Update state
    navigate('/login'); // Redirect to login page
  };

  return (
    <Navbar className={classnames("fixed-top", navbarColor)} expand="lg">
      <Container>
        <div className="navbar-translate">
          <NavbarBrand
            data-placement="bottom"
            tag={Link}
            to="/index"
          >
            Pembroke Farmers Market
          </NavbarBrand>
          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse,
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse
          className="justify-content-end" // This aligns the whole Nav block to the right
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>
            {/* Original Nav Items */}
            <NavItem>
              <NavLink tag={Link} to="/">
                Home
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to="/about">
                About
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to="/vendors">
                Vendors
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to="/calendar">
                Calendar
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink tag={Link} to="/announcement">
                Announcement
              </NavLink>
            </NavItem>

            {/* Reverted back to static Vendor Registration Button */}
            <NavItem>
              <Button
                className="btn-round"
                style={{ backgroundColor: "#1c4922", borderColor: "#1c4922", color: "white" }}
                tag={Link} // Use tag={Link}
                to="/register-page" // Use to="..." for internal routing
              >
                Become a Vendor
              </Button>
            </NavItem>

            {/* Conditional Logout Button (Remains at the end) */}
            {isUserLoggedIn && (
                 <NavItem>
                    <Button
                        className="btn-round btn-icon"
                        color="danger"
                        id="logout-button"
                        onClick={handleLogout}
                        size="sm"
                        style={{ marginTop: '15px', marginBottom: '15px' }}
                    >
                        <i className="nc-icon nc-button-power" />
                    </Button>
                    <UncontrolledTooltip placement="bottom" target="logout-button" delay={0}>
                        Logout
                    </UncontrolledTooltip>
                 </NavItem>
             )}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default IndexNavbar;